module.exports = __webpack_public_path__ + "static/media/schedule_a_call.05d46ae6.svg";